import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';

const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: true,
});

export default Store;
